import {SpinnerActions} from '@store/actions/spinner.actions';
import {SpinnerActionTypes} from '@store/actions/spinner.actions';

export interface SpinnerState {
  show: boolean;
}

const initialState: SpinnerState = {
  show: false
};

export function reducer(
  state: SpinnerState = initialState,
  action: SpinnerActions
) {
  switch (action.type) {
    case SpinnerActionTypes.HideSpinner:
      return {...state, show: false};
    case SpinnerActionTypes.ShowSpinner:
      return {...state, show: true};
    default:
      return state;
  }
}

export const isShowing = (state: SpinnerState) => state.show;
